import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL } from '../common';

@Injectable({
    providedIn: 'root',
})
export class WhatNewService {
    private apiUrlRoot = `${API_URL}/api/whatnew`;

    constructor(private http: HttpClient) {}

    getListWhatNew() {
        return this.http.get<any>(`${this.apiUrlRoot}`);
    }

    getDetailWhatNew(id: string) {
        return this.http.get<any>(`${this.apiUrlRoot}?id=${id}`);
    }
}
